import { enumSidecarSortOption } from '@rematter/frontend-lib-api-client';

import { sidecarDeleteAtom } from '../_graphql/mutationSidecarDelete';
import { sidecarsListQueryAtom } from '../_graphql/querySidecarsList';

export const $remoteSidecars = sidecarsListQueryAtom(() => ({
  variables: {
    sorting: [enumSidecarSortOption.NameAsc],
  },
}));

export const $deleteSidecar = sidecarDeleteAtom({
  onSuccess: (get) => {
    get($remoteSidecars).refetch?.();
  },
});
